import { render, staticRenderFns } from "./fccTipoEnvioSir2.vue?vue&type=template&id=63f7b1fa"
import script from "./fccTipoEnvioSir2.vue?vue&type=script&lang=js"
export * from "./fccTipoEnvioSir2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports